module.exports = __webpack_public_path__ + "img/loaderagrogo.df00d65f.gif";